import { getCtData } from './getCtData';
import { pathSel } from './pathSel';
import { useData } from '../../';

// ----------- set Variable Selection

export const getVarValue = (
  path: string,
  setGet: 'noComponent' | 'Component',
) => {
  const checkString = typeof path !== 'string';
  if (checkString) return [false, null];

  // console.log({ path });
  const condBool = path.includes('{{') && path.includes('}}');
  if (!condBool) return [false, null];

  const varPath = path.replace('{{', '').replace('}}', '');
  if (setGet === 'noComponent') {
    // console.log({ varPath });
    const varValue = getCtData(varPath);
    console.log('dentro getCtData', { varValue });
    return [true, varValue];
  }

  const varValue = useData(ct => pathSel(ct, varPath));
  return [true, varValue];
};
